<div class="eva-3-modal -no-padding -eva-3-hide-medium -eva-3-hide-large currency" CloseModalClick [modal]="this" [ngClass]="{'-show-modal' : isOpen}">
    <div class="modal-header">
      <i class="modal-close eva-3-icon-close" (click)="close()"></i>
      <div class="modal-title-container">
        <p class="modal-title eva-3-h4">{{'currency-modal.label' | translate}}</p>
      </div>
    </div>
    <div class="modal-content">
      <div class="eva-3-dropdown eva-3-filters-vertical -show-filters -eva-3-bc-white">
        <div class="filter-content">
          <ul>
            <li class="currency-item" *ngFor="let currency of currencies">
              <span class="eva-3-radio">
                <label class="radio-label-container" (change)="changeCurrency(currency.value);">
                  <input type="radio" name="currency" class="radio-tag" [checked]="!!currency.selected" [value]="currency.value">
                  <i class="radio-circle"></i>
                  <em>{{ currency.label }}</em>
                </label>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>